import React from "react";
import { SearchProvider, SearchBox } from "@elastic/react-search-ui";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import config from "./config";
import appConfig from "../config";

export default function App() {
  const navigate = (searchText) => {
    if (searchText) {
      const redirectUrl = `${appConfig.keywordSearchAppUrl}?q=${searchText}`;
      window.location.href = redirectUrl;
    }
  };

  return (
    <SearchProvider config={config}>
      <SearchBox
        autocompleteSuggestions={true}
        inputView={({ getAutocomplete, getInputProps, getButtonProps }) => (
          <>
            <div className="p-search">
              <div class="l-inner">
                <div className="p-search__title">
                  <span>SEARCH</span>
                  <i></i>
                </div>
                <div className="p-search__content">
                  <div
                    id="block-topsearch"
                    data-block-plugin-id="keyword_search_block"
                    className="block block-omron-search block-keyword-search-block"
                  >
                    <div className="p-search__input j-input">
                      <label htmlFor="search">Search keyword here</label>
                      <input
                        {...getInputProps({
                          type: "text",
                          placeholder: "Search keyword here",
                        })}
                      />
                      <div class="l-header-search__icon">
                        <label for="dosearch"></label>
                        <input
                          id="dosearch"
                          type="image"
                          src="/themes/custom/omron/assets/img/header/SearchBar_Icn.png"
                          alt="Website Search Bar icon"
                        />
                      </div>
                      {getAutocomplete()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        onSubmit={(searchTerm) => {
          navigate(searchTerm);
        }}
        onSelectAutocomplete={(selection, {}, defaultOnSelectAutocomplete) => {
          if (selection.suggestion) {
            navigate(selection.suggestion);
          } else {
            defaultOnSelectAutocomplete(selection);
          }
        }}
      />
    </SearchProvider>
  );
}
